export const TRANSPORTATION_LOCATIONS = [
  { label: "Almeida", value: "almeida" },
  { label: "Belmonte", value: "belmonte" },
  { label: "Castelo Mendo", value: "castelo_mendo" },
  { label: "Castelo Novo", value: "castelo_novo" },
  { label: "Castelo Rodrigo", value: "castelo_rodrigo" },
  { label: "Idanha-a-velha", value: "idanha_a_velha" },
  { label: "Linhares da Beira", value: "linhares_da_beira" },
  { label: "Marialva", value: "marialva" },
  { label: "Monstanto", value: "monsanto" },
  { label: "Piódão", value: "piodao" },
  { label: "Sortelha", value: "sortelha" },
  { label: "Trancoso", value: "trancoso" },
];

export const TRANSPORTATION_TYPES = [
  { label: "Todos", value: "" },
  { label: "Táxi", value: "taxi" },
  { label: "Táxi (9 lugares)", value: "taxi_9_seats" },
  { label: "Tuk-tuk", value: "tuk_tuk" },
  { label: "Minibus", value: "minibus" },
];

export const TRANSPORTATION = {
  types: {
    taxi: "Táxi",
    taxi_9_seats: "Táxi (9 lugares)",
    tuk_tuk: "Tuk-tuk",
    minibus: "Minibus",
  },
  amenities: {
    electric: "Elétrico",
    bike_carrier: "Porta-bicicletas",
    pet_friendly: "Pet-Friendly",
    trailer: "Reboque",
    mini_bar: "Mini-bar",
  },
};

export const TRANSPORTATION_AMENITIES = [
  { label: "Elétrico", value: "electric" },
  { label: "Porta-bicicletas", value: "bike_carrier" },
  { label: "Pet-friendly", value: "pet_friendly" },
  { label: "Reboque", value: "trailer" },
  { label: "Mini-bar", value: "mini_bar" },
];
